export const contains = function(haystack: string, needle: string): boolean {
    return (haystack || '').indexOf(needle) > -1;
};
